import { store } from "react-notifications-component";
import translate from "../../reusable/translate";

export const startedSavingNotification = () => {
  store.addNotification({
    title: "Tallennus",
    message: "Sitoumusta tallennetaan...",
    type: "info",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showErrorTextNotification = (text) => {
  store.addNotification({
    title: translate({ textKey: "sit.notification.generic.error" }),
    message: text,
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showSuccessTextNotification = (text) => {
  store.addNotification({
    title: translate({ textKey: "sit.notification.success" }),
    message: text,
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const startedSavingReportNotification = () => {
  store.addNotification({
    title: "Tallennus",
    message: "Raporttia tallennetaan...",
    type: "info",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const reportSavedSuccessNotification = () => {
  store.addNotification({
    title: "Onnistui",
    message: "Raportti tallennettu onnistuneesti",
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const reportDraftSavedSuccessNotification = () => {
  store.addNotification({
    title: "Onnistui",
    message: "Luonnos tallennettu onnistuneesti",
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showSuccessNotification = () => {
  store.addNotification({
    title: translate({ textKey: "sit.notification.success" }),
    message: translate({
      textKey: "sit.redux.articles.commitmentSentForVerification",
    }),
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showSaveDraftNotification = () => {
  store.addNotification({
    title: translate({ textKey: "sit.notification.success" }),
    message:
      translate({ textKey: "sit.redux.articles.commitmentSavedAsDraft" }) + "!",
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showDeletedNotification = () => {
  store.addNotification({
    title: translate({ textKey: "sit.notification.success" }),
    message: "Sitoumusluonnos poistettu!",
    type: "success",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 2000,
      onScreen: false,
    },
  });
};

export const showErrorNotification = () => {
  store.addNotification({
    title: "Error",
    message: translate({ textKey: "sit.notification.error" }),
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 5000,
      onScreen: false,
    },
  });
};

export const fillAllFieldsNotification = () => {
  store.addNotification({
    title: "Huom!",
    message: "Täytäthän kaikki kentät ennen raportin julkaisemista",
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 5000,
      onScreen: false,
    },
  });
};

export const fillAllFieldsBeforeDownloadNotification = () => {
  store.addNotification({
    title: "Huom!",
    message: "Täytäthän kaikki kentät ennen raportin lataamista",
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 5000,
      onScreen: false,
    },
  });
};

export const showReportAllOperationsNotification = () => {
  store.addNotification({
    title: "Huom!",
    message: "Täytäthän täytäthän kaikki raportit ennen lähettämistä!",
    type: "danger",
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__zoomIn"],
    animationOut: ["animate__animated", "animate__zoomOut"],
    dismiss: {
      duration: 5000,
      onScreen: false,
    },
  });
};



// WEBPACK FOOTER //
// ./src/components/materialCommitment/helpers/Notifications.js